import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useCurrentLocale } from '../../hooks/useCurrentLocale';
import { FAQ_SCHEMA_BY_LANG } from './faqSchemaData';

/**
 * Emits FAQPage JSON-LD for the current UI language (home page).
 */
export const FaqJsonLd: FC = () => {
    const lang = useCurrentLocale();
    const items = FAQ_SCHEMA_BY_LANG[lang];

    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        inLanguage: lang,
        mainEntity: items.map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
            },
        })),
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </Helmet>
    );
};
